export default "__VITE_ASSET__BV$H4rd2__"